import splitAcImg from "@/assets/split-ac.webp";
import ductedAcImg from "@/assets/ducted-ac.webp";
import ladySofaImg from "@/assets/lady-sofa.webp";

const SystemTypes = () => {
  return (
    <section className="relative pb-16 bg-[#e8edf2]">
      {/* Two background panels side by side */}
      <div className="grid grid-cols-1 md:grid-cols-2">
        {/* Split System - Dark Blue Panel */}
        <div
          className="relative flex flex-col items-center justify-end py-16 px-8 min-h-[500px] bg-cover bg-center"
          style={{ backgroundImage: "url('https://airconditioningguys.com.au/uploads/ac_type_bg_image/split-bg_001.jpg')" }}
        >
          <img
            src={splitAcImg}
            alt="Split System AC Unit"
            className="w-[300px] md:w-[400px] h-auto mb-6"
            width={400}
            height={143}
            loading="lazy"
          />
          <div className="relative z-20 text-center text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-2 drop-shadow-lg">Split System</h2>
            <p className="text-lg mb-4 drop-shadow">Air Conditioning Systems</p>
            <a
              href="#"
              className="inline-block bg-[#b8450e] hover:bg-[#a03c0c] text-white font-semibold px-8 py-3 uppercase tracking-wider text-sm transition-colors"
            >
              See More
            </a>
          </div>
        </div>

        {/* Ducted System - Orange Panel */}
        <div
          className="relative flex flex-col items-center justify-end py-16 px-8 min-h-[500px] bg-cover bg-center"
          style={{ backgroundImage: "url('https://airconditioningguys.com.au/uploads/ac_type_bg_image/ducted-bg_001.jpg')" }}
        >
          <img
            src={ductedAcImg}
            alt="Ducted System AC Vent"
            className="w-[300px] md:w-[400px] h-auto mb-6"
            width={400}
            height={80}
            loading="lazy"
          />
          <div className="relative z-20 text-center text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-2 drop-shadow-lg">Ducted System</h2>
            <p className="text-lg mb-4 drop-shadow">Ducted Air Conditioning Systems</p>
            <a
              href="#"
              className="inline-block bg-[#0078a8] hover:bg-[#006590] text-white font-semibold px-8 py-3 uppercase tracking-wider text-sm transition-colors"
            >
              See More
            </a>
          </div>
        </div>
      </div>

      {/* Lady on sofa overlay */}
      <div className="flex justify-center -mt-16 md:-mt-24 relative z-10">
        <img
          src={ladySofaImg}
          alt="Relaxing with Air Conditioning"
          className="max-w-[90%] md:max-w-[60%] h-auto"
          width={801}
          height={380}
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default SystemTypes;